import { signal } from '@preact/signals';
import { api } from './auth.js';

export const themeState = signal({
  name: '',
  slug: '',
  logo: null,
  banner: null,
  colors: {
    primary: '#16a34a',
    secondary: '#ffffff',
    accent: '#eab308',
    sidebar: '#0b0f14'
  }
});

export async function loadTheme() {
  try {
    const data = await api('/api/clubs/current');
    themeState.value = data;
    applyTheme(data);
  } catch {
    // Use defaults
  }
}

export function applyTheme(theme) {
  if (!theme?.colors) return;
  const root = document.documentElement;
  root.style.setProperty('--color-primary', theme.colors.primary);
  root.style.setProperty('--color-secondary', theme.colors.secondary);
  root.style.setProperty('--color-accent', theme.colors.accent);
  root.style.setProperty('--sidebar-bg', theme.colors.sidebar);
}

export function resetTheme() {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', '#16a34a');
  root.style.setProperty('--color-secondary', '#ffffff');
  root.style.setProperty('--color-accent', '#eab308');
  root.style.setProperty('--sidebar-bg', '#0b0f14');
}

export function lighten(color, amount = 20) {
  const num = parseInt(color.replace('#', ''), 16);
  const r = Math.min(255, (num >> 16) + amount);
  const g = Math.min(255, ((num >> 8) & 0x00FF) + amount);
  const b = Math.min(255, (num & 0x0000FF) + amount);
  return `#${(1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1)}`;
}

export function darken(color, amount = 20) {
  return lighten(color, -amount);
}
